import React from 'react';
import { FormattedMessage } from 'react-intl';
import ServiceEntryStatus from '../../../data/ServiceEntryStatus';
import DateTime from "../../components/ui/DateTime/DateTime";
export default function DetailServiceEntryStatusComponent(props) {
    var serviceEntryModel = props.serviceEntryModel;
    return React.createElement("div", null,
        React.createElement("i", { className: 'fe fe-activity mr-3 service-entry-status__icon service-entry-status--' + ServiceEntryStatus.getKeyByValue(serviceEntryModel.calculatedStatus) }),
        React.createElement(FormattedMessage, { id: 'detail.service.entry.status.' + ServiceEntryStatus.getKeyByValue(serviceEntryModel.calculatedStatus) }),
        serviceEntryModel.calculatedStatus == ServiceEntryStatus.Closed && ":",
        React.createElement(DateTime, { relativeTimeClasses: "text-muted", hideTime: true, date: serviceEntryModel.closeDateTimeUtc }));
}
